@if (changeOfficeService.offices$ | async; as offices) {
    @if (changeOfficeService.currentOffice$ | async; as currentOffice) {
        <div
            (clickOutside)="changeListVisible(false)"
            class="change-office-container"
        >
            <bil-main-select
                [isOpen]="clicked$ | async"
                [isOpenable]="offices?.length > 1"
                (onClick)="changeListVisible($event)"
            >
                <bil-icon name="far fa-city"></bil-icon>
                {{ currentOffice.denomination }}
            </bil-main-select>
            @if (listVisible$ | async) {
                <div class="change-office-list">
                    @for (office of offices; track office) {
                        <div>
                            <div
                                (click)="
                                    changeOffice(
                                        office.id,
                                        office.tenantId,
                                        currentOffice.id,
                                        currentOffice.tenantId
                                    )
                                "
                                class="change-office-item"
                            >
                                {{ office.denomination }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
}
